import {Component, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-quality',
  templateUrl: './quality.component.html',
  styleUrls: ['./quality.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class QualityComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
